'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TRACK_SIGN_OUT = exports.TRACK_SIGN_OUT = 'User Signed Out';
// export const TRACK_FLIGHT_EDITED = 'Flight Edited';
// export const TRACK_FLIGHT_EXPORTED = 'Flight Data Exported';
var TRACK_BALLOON_LAUNCHED = exports.TRACK_BALLOON_LAUNCHED = 'Balloon Launched';
var TRACK_BALLOON_DELETED = exports.TRACK_BALLOON_DELETED = 'Balloon Deleted';
var TRACK_BALLOON_PUMPED = exports.TRACK_BALLOON_PUMPED = 'Balloon Pumped';
// export const TRACK_BALLOON_EDITED = 'Balloon Edited';
var TRACK_BALLOON_CLAIMED = exports.TRACK_BALLOON_CLAIMED = 'Balloon Claimed';
var TRACK_BALLOON_UNCLAIMED = exports.TRACK_BALLOON_UNCLAIMED = 'Balloon Unclaimed';
var TRACK_COMMENT_ADDED = exports.TRACK_COMMENT_ADDED = 'Comment Added';
var TRACK_COMMENT_CLAIMED = exports.TRACK_COMMENT_CLAIMED = 'Comment Claimed';
var TRACK_COMMENT_UNCLAIMED = exports.TRACK_COMMENT_UNCLAIMED = 'Comment Unclaimed';
// TRACK_NAMED_SEGMENT_CREATED = 'Named Segment Created';
var TRACK_FLIGHT_PLAN_USED = exports.TRACK_FLIGHT_PLAN_USED = 'Flight Plan Used';